export const venueTypes = [
    {
        name: 'bar',
        label: 'Bar',
        val: 1,
        selected: false
    },
    {
        name: 'brewery',
        label: 'Brewery',
        val: 7,
        selected: false
    },
    {
        name: 'cafe',
        label: 'Cafe',
        val: 2,
        selected: false
    },
    {
        name: 'corporate',
        label: 'Corporate',
        val: 9,
        selected: false
    },
    {
        name: 'event-space',
        label: 'Event Space',
        val: 10,
        selected: false
    },
    {
        name: 'gallery',
        label: 'Gallery',
        val: 11,
        selected: false
    },
    {
        name: 'music-concert-venue',
        label: 'Music/Concert Venue',
        val: 3,
        selected: false
    },
    {
        name: 'nightclub',
        label: 'Nightclub',
        val: 4,
        selected: false
    },
    {
        name: 'private',
        label: 'Private',
        val: 12,
        selected: false
    },
    {
        name: 'restaurant',
        label: 'Restaurant',
        val: 5,
        selected: false
    },
    {
        name: 'winery',
        label: 'Winery',
        val: 8,
        selected: false
    },
    {
        name: 'other',
        label: 'Other',
        val: 6,
        selected: false
    }
]
